var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('a',{staticClass:"clearfix",attrs:{"href":_vm.team_base_route + _vm.team.contestant_id}},[_c('span',{staticClass:"badge"},[_c('img',{attrs:{"src":_vm.team.logo_path}})]),_vm._v(" "),_c('span',{staticClass:"name"},[_vm._v(_vm._s(_vm.team.club_name))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }